import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function Budget_calculation() {
  const active_pro_name = localStorage.getItem('selected_project_name');
  const [listProjectMembersArray, setListProjectMembersArray] = useState([]);
  const [existingSalary, setExistingSalary] = useState({});
  const [existingFixedCost, setExistingFixedCost] = useState({});
  const [budgetStatus, setBudgetStatus] = useState({
    salary_complete: false,
    fixed_cost_complete: false,
    earn_complete: false,
    total_members: 0,
    members_with_salary: 0,
    missing_members: []
  });
  const [activeTab, setActiveTab] = useState(null); // salary | fixed | earn
  const [salaryInputs, setSalaryInputs] = useState({});
  const [fixedCost, setFixedCost] = useState({
    rent: '',
    electricity: '',
    internet: '',
    maintenance: '',
    other: ''
  });

  const [earnAmount, setEarnAmount] = useState('');
  const [calculation, setCalculation] = useState(null);
  const [membretype, setMembertype] = useState(false);
  const navigate = useNavigate();
  const COLORS = ["#4CAF50", "#FF9800", "#2196F3"];
  useEffect(() => { 
    let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
    const active_pro_id = localStorage.getItem('selected_project_id');

    var obj = {
      pro_id: active_pro_id
    };

    fetch('getAllProjectMember.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.json()) // same as your original (not JSON)
      .then(result => {
        console.log(result);

        var res = result;

        if (res !== 'fail' && res !== '') {
          try {
            var memarr = res;

            // If your backend actually returns JSON string, then use this instead:
            // var memarr = JSON.parse(res);

            if (Array.isArray(memarr)) {
              setListProjectMembersArray(memarr);

            } else {
              showAlert('Cannot find any active member for this project.');
              setListProjectMembersArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            document.getElementById('memnum').innerText = '0';
            setListProjectMembersArray([]);
          }
        } else {
          showAlert('Cannot find any active member for this project.');
          setListProjectMembersArray([]);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
  }, [])

  useEffect(() => {
    const project_id = localStorage.getItem('selected_project_id');
    const company_id = localStorage.getItem('mem_company_id');

    fetch(`check_budget_status.php?company_id=${company_id}&project_id=${project_id}`)
      .then(res => res.json())
      .then(data => {
        console.log("Budget Status:", data);
        setBudgetStatus(data);
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    if (
      budgetStatus.salary_complete &&
      budgetStatus.fixed_cost_complete &&
      budgetStatus.earn_complete
    ) {
      fetchCalculation();
    }
  }, [budgetStatus]);

  useEffect(() => {
    if (activeTab === 'edit') {
      fetchExistingData();
    }
  }, [activeTab]);


  const missingSet = new Set(
    budgetStatus.missing_members.map(m => m.member_id)
  );

  const combinedMembers = listProjectMembersArray.map(member => ({
    ...member,
    isMissing: missingSet.has(member.memberid)
  }));

  function fetchCalculation() {
    const project_id = localStorage.getItem('selected_project_id');
    const company_id = localStorage.getItem('mem_company_id');

    fetch(`calculate_budget.php?project_id=${project_id}&company_id=${company_id}`)
      .then(res => res.json())
      .then(data => {
        console.log("Calculation:", data);
        setCalculation(data);
      });
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function saveSalary() {
    const company_id = localStorage.getItem('mem_company_id');

    const payload = {
      company_id,
      salaries: salaryInputs
    };
    console.log(payload)
    fetch('save_salary.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.text())
      .then(data => {

        setActiveTab(null);
        localStorage.setItem('initialpage', 'budget');
        navigate('/redirect_task');
      });
  }

  function updateSaveSalary() {
    const company_id = localStorage.getItem('mem_company_id');

    let finalSalaryData = {};

    listProjectMembersArray.forEach(member => {
      const memberId = member.memberid;

      const existing = existingSalary[memberId] || {};
      const updated = salaryInputs[memberId] || {};

      finalSalaryData[memberId] = {
        salary: updated.salary || existing.salary_amt || 0,
        hours: updated.hours || existing.hours_working || 0
      };
    });

    const payload = {
      company_id,
      salaries: finalSalaryData
    };

    console.log(payload);

    fetch('save_salary.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => res.text())
      .then(data => {
        setActiveTab(null);
        localStorage.setItem('initialpage', 'budget');
        navigate('/redirect_task');
      });
  }

  function saveFixedCost() {
    const company_id = localStorage.getItem('mem_company_id');

    fetch('save_fixed_cost.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...fixedCost, company_id })
    })
      .then(res => res.json())
      .then((data) => {
        console.log(data);
        setActiveTab(null);
        localStorage.setItem('initialpage', 'budget');
        navigate('/redirect_task');
      });
  }


  function updateFixedCost() {
  const company_id = localStorage.getItem('mem_company_id');

const payload = {
  company_id,
  rent: fixedCost.rent || existingFixedCost.office_rent || 0,
  electricity: fixedCost.electricity || existingFixedCost.electricity || 0,
  internet: fixedCost.internet || existingFixedCost.internet || 0,
  maintenance: fixedCost.maintenance || existingFixedCost.other_exp || 0,
  other: fixedCost.other || existingFixedCost.other_cost || 0
};

  console.log(payload);

  fetch('update_fixed_cost.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(res => res.json())
    .then((data) => {
      console.log(data);
     setActiveTab(null);
        localStorage.setItem('initialpage', 'budget');
        navigate('/redirect_task');
    });
}

  function saveEarn() {
    const company_id = localStorage.getItem('mem_company_id');
    const project_id = localStorage.getItem('selected_project_id');

    fetch('save_earn.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        company_id,
        project_id,
        earnAmount
      })
    })
      .then(res => res.json())
      .then(() => {
        setActiveTab(null);
        localStorage.setItem('initialpage', 'budget');
        navigate('/redirect_task');
      });
  }


  function downloadPDF() {
    const element = document.getElementById("mainreport");
    const chart = document.querySelector(".chart-box");

    if (!element) {
      console.error("Report element not found");
      return;
    }

    // Hide chart (SVG issue)
    if (chart) chart.style.display = "none";

    setTimeout(() => { // 🔥 ensure DOM update after hiding
      html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {

        // 🔴 Safety checks
        if (!canvas || canvas.width === 0 || canvas.height === 0) {
          throw new Error("Canvas is empty or invalid");
        }

        const imgData = canvas.toDataURL("image/jpeg", 0.9);

        if (!imgData || !imgData.startsWith("data:image")) {
          throw new Error("Invalid image data generated");
        }

        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const margin = 10;
        const usableWidth = pageWidth - (margin * 2);

        const imgHeight = (canvas.height * usableWidth) / canvas.width;

        // 🔥 Prevent overflow
        let finalHeight = imgHeight;
        if (imgHeight > pageHeight - 20) {
          finalHeight = pageHeight - 20;
        }

        pdf.addImage(
          imgData,
          "JPEG",
          margin,
          10,
          usableWidth,
          finalHeight
        );

        pdf.save("budget-report.pdf");

        if (chart) chart.style.display = "block";

      }).catch(err => {
        console.error("PDF Error:", err);
        if (chart) chart.style.display = "block";
      });

    }, 300); // 🔥 delay helps fix rendering issues
  }


  function getAlert(calculation) {
    if (!calculation) return null;

    if (calculation.profit < 0) {
      return { type: "danger", msg: "⚠ This project is running at a LOSS!" };
    }

    if (calculation.margin < 10) {
      return { type: "warning", msg: "⚠ Low profit margin. Try reducing cost." };
    }

    if (calculation.margin > 30) {
      return { type: "success", msg: "✔ Healthy profit margin." };
    }

    return null;
  }


  const chartData = calculation ? [
    { name: "Earn", value: calculation.earn },
    { name: "Cost", value: calculation.total_cost },
    { name: "Profit", value: calculation.profit }
  ] : [];

  const showEditOption =
    budgetStatus.salary_complete &&
    budgetStatus.fixed_cost_complete;

  function fetchExistingData() {
    const company_id = localStorage.getItem('mem_company_id');

    fetch(`get_existing_budget.php?company_id=${company_id}`)
      .then(res => res.json())
      .then(data => {

        setExistingSalary(data.salary);
        setExistingFixedCost(data.fixed);
      });
  }
  return (
    <div>
      <div className='topbar_menu'>

        <p>Project name : {active_pro_name}</p>
        <p className='noticebox'><i className='ri-information-line'></i>This is an estimated calculation based on provided data. Actual results may vary</p>
      </div>
      <div className='member_row'>
        <div className='top_tab_area'>

          {/* Salary Button */}
          {!budgetStatus.salary_complete && (
            <button className='cost_tabs activebtn' onClick={() => setActiveTab('salary')}>
              Salary ({budgetStatus.members_with_salary}/{budgetStatus.total_members})
            </button>
          )}

          {!budgetStatus.fixed_cost_complete && (
            <button className='cost_tabs' onClick={() => setActiveTab('fixed')}>
              Fixed Costs
            </button>
          )}

          {!budgetStatus.earn_complete && (
            <button className='cost_tabs' onClick={() => setActiveTab('earn')}>
              Earn
            </button>
          )}

          {showEditOption && (
            <div className="edit-section">
              <button className='cost_tabs mt-15' onClick={() => setActiveTab('edit')}>
                ✏️ Edit Budget Data
              </button>
            </div>
          )}

        </div>

        <div className="status_area">
          {!budgetStatus.salary_complete && (
            <p>⚠ Salary added for {budgetStatus.members_with_salary} out of {budgetStatus.total_members} members</p>
          )}

          {!budgetStatus.fixed_cost_complete && (
            <p>⚠ Please add fixed company costs</p>
          )}

          {!budgetStatus.earn_complete && (
            <p>⚠ Please add project earning</p>
          )}
        </div>
        <div className='informationform'>
          {activeTab === 'salary' && (
            <div className='information_insert_area'>
              <div className='information_container'>
                <h2>Salary</h2>

                {combinedMembers
                  .filter(m => m.isMissing)
                  .map(member => (
                    <div key={member.memberid} className='info_formfield'>
                      <div className='width25 pull_left'>
                        <p>{member.membername}</p>
                      </div>

                      <div className='width25 pull_left pr-40'>
                        <input
                          type="number"
                          placeholder='Salary'
                          onChange={(e) =>
                            setSalaryInputs(prev => ({
                              ...prev,
                              [member.memberid]: {
                                ...prev[member.memberid],
                                salary: e.target.value
                              }
                            }))
                          }
                        />
                      </div>

                      <div className='width25'>
                        <input
                          type="number"
                          placeholder='Working Hours'
                          onChange={(e) =>
                            setSalaryInputs(prev => ({
                              ...prev,
                              [member.memberid]: {
                                ...prev[member.memberid],
                                hours: e.target.value
                              }
                            }))
                          }
                        />
                      </div>
                    </div>
                  ))}

                <button onClick={saveSalary}>Save All</button>
              </div>
            </div>
          )}

          {activeTab === 'fixed' && (
            <div className='information_insert_area ' id="fixed_cost">
              <div className='information_container'>
                <h2 className='information_heading'>Monthly Fixed Costs</h2>
                <p>For your better understanding you  should use your local currency</p>
                <div className='info_formarea'>
                  <div className='info_formfield'>
                    <div className='width40 pull_left pr_10'>
                      <p>Office Rent</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="rent" placeholder='Office rent' onChange={e => setFixedCost({ ...fixedCost, rent: e.target.value })} />
                    </div>
                  </div>

                  <div className='info_formfield' >
                    <div className='width40 pull_left pr_10'>
                      <p>Electricity</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="electricity" placeholder='Electricity' onChange={e => setFixedCost({ ...fixedCost, electricity: e.target.value })} />
                    </div>
                  </div>

                  <div className='info_formfield'>
                    <div className='width40 pull_left pr_10'>
                      <p>Internet</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="internet" placeholder='Internet' onChange={e => setFixedCost({ ...fixedCost, internet: e.target.value })} />
                    </div>
                  </div>

                  <div className='info_formfield'>
                    <div className='width40 pull_left pr_10'>
                      <p>Maintenance</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="maintanance" placeholder='Maintenance' onChange={e => setFixedCost({ ...fixedCost, maintenance: e.target.value })} />
                    </div>
                  </div>

                  <div className='info_formfield'>
                    <div className='width40 pull_left pr_10'>
                      <p>Others</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="other_cost" placeholder='Others' onChange={e => setFixedCost({ ...fixedCost, other: e.target.value })} />
                    </div>
                  </div>

                  <div className='vl_dsh_buttonholder'>
                    <button onClick={saveFixedCost}><i className='ri-save-2-fill'></i> Save</button>
                  </div>

                </div>
              </div>
            </div>
          )}
          {activeTab === 'earn' && (
            <div className='information_insert_area ' id="earn_amt">
              <div className='information_container'>
                <h2 className='information_heading'>Earn</h2>
                <p>For your better understanding you  should convert the value to your local currency</p>
                <div className='info_formarea'>
                  <div className='info_formfield'>
                    <div className='width50 pull_left pr_10'>
                      <p>Total Earn From This Project</p>
                    </div>
                    <div className='width40 pull_left pr_10'>
                      <input type="text" className="earn" placeholder='Earning Amount' onChange={e => setEarnAmount(e.target.value)} />
                      <p className='smalltext'>Insert the total value of the project.Use only number</p>
                    </div>
                  </div>


                  <div className='vl_dsh_buttonholder'>
                    <button onClick={saveEarn}><i className='ri-save-2-fill'></i> Save</button>
                  </div>

                </div>
              </div>
            </div>

          )}
          {activeTab === 'edit' && (
            <div className="edit_information_insert_area">
              <button className='clsbtn' onClick={() => setActiveTab(null)}>+</button>

              <h2 className='editcaption'>Update Salary</h2>

              {listProjectMembersArray.map(member => {

                const data = existingSalary[member.memberid] || {};

                return (
                  <div key={member.memberid} className="info_formfield">
                    <div className='width25 pull_left over-y-hidden'>
                      <p className='pt-24'>{member.membername}</p>
                    </div>
                    <div className='width25 pull_left pr-40'>
                      <label>Salary</label>
                      <input
                        type="number"
                        defaultValue={data.salary_amt || ''}
                        onChange={(e) =>
                          setSalaryInputs(prev => ({
                            ...prev,
                            [member.memberid]: {
                              ...prev[member.memberid],
                              salary: e.target.value
                            }
                          }))
                        }
                      />
                    </div>
                    <div className='width25 pull_left'>
                      <label>Working Hours(Monthly)</label>
                      <input
                        type="number"
                        defaultValue={data.hours_working || ''}
                        onChange={(e) =>
                          setSalaryInputs(prev => ({
                            ...prev,
                            [member.memberid]: {
                              ...prev[member.memberid],
                              hours: e.target.value
                            }
                          }))
                        }
                      />
                    </div>
                  </div>
                );
              })}
              <div className='vl_dsh_buttonholder mb-30'>
                <button onClick={updateSaveSalary}>Update Salary</button>
              </div>

              <hr></hr>

              <h2 className='editcaption'>Edit Fixed Cost</h2>
              <div className='info_formfield'>
                <div className='info_formarea pt-15'>
                  <div className='width40 pull_left pr_10'>
                    <p>Office Rent</p>
                  </div>
                  <div className='width40 pull_left pr_10'>
                    <input
                      defaultValue={existingFixedCost.office_rent || ''}
                      onChange={(e) =>
                        setFixedCost(prev => ({ ...prev, rent: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className='info_formarea pt-15'>
                  <div className='width40 pull_left pr_10'>
                    <p>Electricity</p>
                  </div>
                  <div className='width40 pull_left pr_10'>
                    <input
                      defaultValue={existingFixedCost.electricity || ''}
                      onChange={(e) =>
                        setFixedCost(prev => ({ ...prev, electricity: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className='info_formarea pt-15'>
                  <div className='width40 pull_left pr_10'>
                    <p>Internet</p>
                  </div>
                  <div className='width40 pull_left pr_10'>
                    <input
                      defaultValue={existingFixedCost.internet || ''}
                      onChange={(e) =>
                        setFixedCost(prev => ({ ...prev, internet: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className='info_formarea pt-15'>
                  <div className='width40 pull_left pr_10'>
                    <p>Other Office Expences</p>
                  </div>
                  <div className='width40 pull_left pr_10'>
                    <input
                      defaultValue={existingFixedCost.other_exp || ''}
                      onChange={(e) =>
                        setFixedCost(prev => ({ ...prev, maintenance: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className='info_formarea pt-15'>
                  <div className='width40 pull_left pr_10'>
                    <p>Other Costs</p>
                  </div>
                  <div className='width40 pull_left pr_10'>
                    <input
                      defaultValue={existingFixedCost.other_cost || ''}
                      onChange={(e) =>
                        setFixedCost(prev => ({ ...prev, other: e.target.value }))
                      }
                    />
                  </div>
                </div>

                <div className='vl_dsh_buttonholder'>
                  <button className='specialButton' onClick={updateFixedCost}>Update Fixed Cost</button>
                </div>
              </div>

            </div>
          )}


        </div>
        {calculation && (
          <div className='fullwidth pull_left' id="report">

            {/* ALERT */}
            {getAlert(calculation) && (
              <div className={`alert ${getAlert(calculation).type}`}>
                {getAlert(calculation).msg}
              </div>
            )}

            <div className="dashboard" id="mainreport">
              <h2>Financial Information</h2>
              <div className="card profit">
                <h3>{calculation.profit >= 0 ? "Profit" : "Loss"}</h3>
                <p>{Math.abs(calculation.profit)}</p>
              </div>

              <div className="card">
                <h3>Total Earn</h3>
                <p>{calculation.earn}</p>
              </div>

              <div className="card">
                <h3>Total Cost</h3>
                <p>{calculation.total_cost}</p>
              </div>

              <div className="card">
                <h3>Margin</h3>
                <p>{calculation.margin}%</p>
              </div>

            </div>

            {/* CHART */}
            <div className="chart-box">
              <h3>Financial Overview</h3>

              <div className="chart-wrapper">
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={chartData}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="value">
                      {chartData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index]} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>

          </div>
        )}
        <div className='vl_dsh_buttonholder'>
          <button onClick={downloadPDF}>Download PDF</button>
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
      {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
    </div>
  )
}
